/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Done_TitleInputs */



/**
* | output |
* | --- |
* | "Captions embedded" |
*
* @param {Embed_Captions_Local_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_done_title = /** @type {((inputs?: Embed_Captions_Local_Done_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Done_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Légendes intégrées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingebettete Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli incorporati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроенные субтитлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos incrustados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入式字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕が埋め込まれています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन शामिल हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas incorporadas")
	return /** @type {LocalizedString} */ ("Captions embedded")
});